import { useQuery } from '@tanstack/react-query';
import apiClient from '../lib/api-client';

const fetchFactsheets = async () => {
  try {
    const response = await apiClient.get('/factsheets');
    return response.data;
  } catch (error) {
    // Handle 404 - "No factsheet document found" as empty result, not error
    if (error.response?.status === 404) {
      const message = error.response?.data?.message || 'No factsheets available.';
      // Return empty successful response
      return {
        success: true,
        data: [],
        message: message
      };
    }
    // Re-throw other errors
    throw error;
  }
};

export const useGetFactsheets = (enabled = false) => {
  return useQuery({
    queryKey: ['factsheets'],
    queryFn: () => fetchFactsheets(),
    enabled,
  });
};
